export enum Routes {
  HOME = '/home',
  LOGIN = '/login',
  REGISTER = '/register',
  INFORMATION = '/information',
  INICIO = '/app/inicio',
  EDIT_USER = '/app/perfil',
  ACTIVE_COURSE = '/app/course-active',
  STUDENT_COURSES = '/app/student-courses',
  COURSES = '/app/courses',
}
